<div class="container">
	<div class="overlay-bg"></div>
	<div class="mid-content">
		@if (form) {
			<div
				class="p-relative form-container"
				style="
					margin-right: 1px;
					border-top-left-radius: 25px;
					border-bottom-left-radius: 25px;
					background-color: white;
				">
				<div @fadeAndSlideUp>
					<form novalidate [formGroup]="form" (submit)="register(form.value)">
						<p-card class="nice-border">
							<div class="ui-g login-block p-1">
								<div class="ui-g-12 ui-lg-12 p-0">
									<div class="text-center">
										<img src="./assets/img/smartyCubes-logo.png" alt="SmartyCube" />
									</div>
									<label style="text-align: center">
										<b style="font-weight: 500">{{ 'login.register-password-title' | translate }}</b>
									</label>
								</div>
								<div class="ui-lg-12 ui-md-12 ui-g-12">
									<label>
										<b>{{ 'login.password' | translate }}</b>
									</label>
									<input
										placeholder="{{ 'login.password' | translate }}"
										type="password"
										class="w-100"
										pPassword
										[feedback]="false"
										name="password"
										formControlName="password" />
									<span class="information">
										<i class="fas fa-question-circle"></i>
										{{ 'login.valid-password-title-without-example' | translate }}
									</span>
									<sis-validation-summary
										[form]="form"
										name="password"
										[visible]="invalidForm"></sis-validation-summary>
								</div>
								<div class="ui-lg-12 ui-md-12 ui-g-12 pb-2">
									<label>
										<b>{{ 'login.confirm-password' | translate }}</b>
									</label>
									<input
										placeholder="{{ 'login.confirm-password' | translate }}"
										type="password"
										class="w-100"
										pPassword
										[feedback]="false"
										name="confirmPassword"
										formControlName="confirmPassword" />
									<sis-validation-summary
										[form]="form"
										name="confirmPassword"
										[visible]="invalidForm"></sis-validation-summary>
								</div>
								<ng-template #footer>
									<div class="ui-lg-12 login-border text-right">
										<button
											pButton
											type="submit"
											label="{{ 'login.create-password-and-login' | translate }}"
											icon="fas fa-unlock-alt"
											[disabled]="form.invalid"
											class="action-btn btn-color ui-green-button"></button>
									</div>
								</ng-template>
							</div>
						</p-card>
					</form>
				</div>
			</div>
		}
		<div class="p-relative img-container">
			<div style="height: 100%" @fadeAndSlideUp>
				<div class="card-right" style="margin-left: -1px">
					<img src="./assets/img/smartyCube-login-image.png" />
				</div>
			</div>
		</div>
	</div>
</div>

<p-dialog
	[header]="'2FA' | translate"
	[(visible)]="isDialogVisible"
	[style]="{ width: '500px' }"
	[modal]="true"
	[contentStyle]="{ 'min-height': '25vh' }"
	(onHide)="resetAll()">
	<div class="ui-g" [formGroup]="loginForm">
		<div class="ui-lg-1 ui-md-1 ui-g-12 read-only"></div>
		<div class="ui-lg-10 ui-md-10 ui-g-12 read-only">
			<div class="iconLock">
				<span><i class="fa fa-unlock-alt"></i></span>
			</div>
			<span class="loginParameter">{{ loginParametersInfo?.user2FAContactInfo }} {{ '2faLabel' | translate }}</span>
		</div>
		<div class="ui-lg-1 ui-md-1 ui-g-12 read-only text-right"></div>
		<div class="ui-lg-2 ui-md-2 ui-g-12 read-only"></div>

		<div class="ui-lg-8 ui-md-8 ui-g-12 text-right">
			<fieldset>
				<input
					type="text"
					name="password"
					id="password-input"
					formControlName="code"
					inputmode="numeric"
					(keyup.enter)="control()"
					autofocus
					minlength="5"
					maxlength="5"
					size="5"
					value="" />
			</fieldset>
		</div>
		<div class="ui-lg-2 ui-md-2 ui-g-12 read-only"></div>
	</div>
	<ng-template #footer>
		<div class="pt-0">
			<div class="ui-g">
				<div class="ui-g-4 ui-md-4 ui-g-12 text-center">
					@if (!isRetryTimerEnds) {
						<div>
							<span class="iconTimer"><i class="fa fa-clock"></i></span>
							<span class="iconTimerText">
								{{ timer }}
								<span class="sn">sn.</span>
							</span>
						</div>
					}
					@if (isRetryTimerEnds) {
						<button
							type="button"
							pButton
							label="{{ 'retryToConnect' | translate }}"
							(click)="retryToConnect()"
							class="ui-dark-button w-100"></button>
					}
				</div>
				<div class="ui-g-8 ui-md-8 ui-g-12 text-right pr-0">
					<button
						type="button"
						pButton
						label="{{ 'control' | translate }}"
						(click)="control()"
						[disabled]="loginForm.invalid"
						class="ui-green-button"></button>
				</div>
			</div>
		</div>
	</ng-template>
</p-dialog>
